import React, { useState, useEffect } from "react";

const BASE_COINS = 20;
const BOOST_MILESTONES = {
  3:  { boost: "lucky_charm", label: "Lucky Charm",  emoji: "🍀" },
  7:  { boost: "rare_surge",  label: "Rare Surge",   emoji: "⚡" },
  14: { boost: "jackpot",     label: "Jackpot Mode", emoji: "💎" },
};

function getToday() { return new Date().toDateString(); }

function calcStreak(lastClaim, currentStreak, boosts) {
  if (!lastClaim) return { streak: 0, freezeUsed: false };
  const diff = Math.floor((new Date() - new Date(lastClaim)) / (1000 * 60 * 60 * 24));
  if (diff === 0) return { streak: currentStreak, freezeUsed: false };
  if (diff === 1) return { streak: currentStreak, freezeUsed: false };
  if (diff === 2 && boosts?.streak_freeze) {
    return { streak: currentStreak, freezeUsed: true };
  }
  return { streak: 0, freezeUsed: false };
}

export function checkDailyStreak(boosts) {
  const lastClaim     = localStorage.getItem("lastClaim");
  const currentStreak = parseInt(localStorage.getItem("streak") || "0", 10);
  const today         = getToday();
  if (lastClaim === today) return null;
  const { streak: base, freezeUsed } = calcStreak(lastClaim, currentStreak, boosts);
  const newStreak = base + 1;
  const coins     = BASE_COINS * Math.min(newStreak, 10);
  const milestone = BOOST_MILESTONES[newStreak] || null;
  return { newStreak, coins, milestone, today, freezeUsed };
}

export default function DailyStreak({ boosts, onClaim, onClose }) {
  const [result] = useState(() => checkDailyStreak(boosts));

  useEffect(() => { if (!result) onClose(); }, [result, onClose]);
  if (!result) return null;

  const { newStreak, coins, milestone, freezeUsed } = result;
  const nextMilestone = Object.keys(BOOST_MILESTONES).map(Number).find(d => d > newStreak);

  const handleClaim = () => {
    localStorage.setItem("lastClaim", result.today);
    localStorage.setItem("streak",    result.newStreak);
    onClaim({ coins, milestone, newStreak, freezeUsed });
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box streak-box" onClick={e => e.stopPropagation()}>
        <div className="streak-flame">🔥</div>
        <h2 style={{ marginBottom: 4 }}>Daily Streak!</h2>
        <p className="streak-day">Day {newStreak}</p>

        {freezeUsed && (
          <div className="streak-freeze-banner">🧊 Streak Freeze used — your streak was protected!</div>
        )}

        <div className="streak-bar-row">
          {[1,2,3,4,5,6,7].map(d => {
            const isMilestone = !!BOOST_MILESTONES[d];
            const isDone      = d <= newStreak;
            return (
              <div key={d} className={`streak-dot${isDone ? " done" : ""}${isMilestone ? " milestone" : ""}`}>
                {isMilestone ? BOOST_MILESTONES[d].emoji : (isDone ? "✓" : d)}
              </div>
            );
          })}
        </div>

        <div className="streak-reward-box">
          <div className="streak-reward-label">Today's reward</div>
          <div className="streak-coins">+{coins} coins</div>
          {milestone && (
            <div className="streak-bonus">{milestone.emoji} Milestone bonus: <strong>{milestone.label}</strong> activated!</div>
          )}
        </div>

        {nextMilestone && !milestone && (
          <p className="streak-next">
            {nextMilestone - newStreak} more day{nextMilestone - newStreak > 1 ? "s" : ""} until {BOOST_MILESTONES[nextMilestone].emoji} {BOOST_MILESTONES[nextMilestone].label}
          </p>
        )}

        <button onClick={handleClaim} className="btn-primary" style={{ marginTop: 20, width: "100%" }}>
          Claim Reward
        </button>
      </div>
    </div>
  );
}